import { useState } from 'react';
import { readConsent, setConsent, trackEvent } from '../../lib/analytics';

// Cookie notice for GA4 + the Meta Pixel — the booking-app twin of
// CookieNotice.astro on the marketing site. Same copy, same choices, same ag_consent cookie (written on
// .alfrescogrand.com), so a visitor who already chose on www never sees it
// here, and a choice made here is honoured back on www.
//
// Bottom-left, fixed, no layout shift. Sits below ModalShell (z-50) so a
// booking modal always wins.
export default function CookieNotice() {
  const [open, setOpen] = useState(() => readConsent() === null);

  if (!open) return null;

  const choose = (value) => {
    setConsent(value);
    // Records the choice itself so the accept rate is measurable. Events are
    // sent regardless of consent state (cookieless when denied), so this
    // fires for both answers. Same event + param as the marketing site.
    trackEvent('consent_choice', { choice: value });
    setOpen(false);
  };

  return (
    <div
      role="region"
      aria-label="Cookie notice"
      className="fixed bottom-4 left-4 right-4 z-40 sm:bottom-6 sm:left-6 sm:right-auto sm:max-w-sm p-px rounded-2xl bg-gradient-to-b from-[rgba(212,168,67,0.32)] via-[rgba(255,255,255,0.06)] to-[rgba(255,255,255,0.02)] motion-safe:animate-[fadeInUp_0.6s_cubic-bezier(0.16,1,0.3,1)_both]"
    >
      <div className="bg-[#0D1E35]/95 backdrop-blur rounded-[15px] shadow-[0_24px_48px_rgba(0,0,0,0.5)] px-5 py-4">
        <p className="font-dm-sans text-sm text-white/65 font-light leading-relaxed">
          We use cookies to improve your experience, understand how the site is used and measure our advertising. See our{' '}
          <a
            href="https://www.alfrescogrand.com/privacy"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#C9A84C] underline underline-offset-2 hover:text-[#B8973E] transition-colors duration-200"
          >
            Privacy Policy
          </a>
          .
        </p>
        <div className="mt-3 flex items-center gap-3">
          <button
            type="button"
            onClick={() => choose('granted')}
            className="px-4 py-2 bg-[#C9A84C] text-[#0A1628] font-dm-sans font-medium text-[11.5px] tracking-[0.15em] uppercase rounded-full active:scale-[0.97] hover:bg-[#B8973E] transition-[transform,background-color] duration-[160ms] ease-[cubic-bezier(0.23,1,0.32,1)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgba(201,168,76,0.5)] focus-visible:ring-offset-2 focus-visible:ring-offset-[#0D1E35]"
          >
            Accept
          </button>
          <button
            type="button"
            onClick={() => choose('denied')}
            className="px-3 py-2 font-dm-sans text-[13px] text-white/45 hover:text-white underline-offset-4 hover:underline transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgba(201,168,76,0.5)] rounded-full"
          >
            Only essential
          </button>
        </div>
      </div>
    </div>
  );
}
